"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaiveRow = void 0;
class NaiveRow {
    constructor(index, columns) {
        this.index = index;
        this.columns = columns;
    }
}
exports.NaiveRow = NaiveRow;
